export default {
    'form.name':'姓名',
    'form.email':'邮箱',
    'form.email.code':'邮箱验证码',
    'form.country':'国家',
    'form.password':'密码',
    'form.requiredText':'请输入',
    'form.send-emil-success':'验证码已发送',
    'form.send-emil-fail':'验证码发送失败',
    'form.send-email-code':'发送验证码',
    'form.email-valid-error':'邮箱格式错误',
    'form.second-send-again':'秒后重发',
    'form.upload.idFront':'身份证正面',
    'form.upload.idBack':'身份证背面',
    'form.upload.validType':'仅支持上传 JPG/PNG 格式的图片！',
    'form.upload.validSize':'图片大小不能超过 2MB！',
    'form.last-name':'姓氏',
    'form.first-name':'名字',
    'form.birthday':'生日',
    'form.nickname':'昵称',
    'form.phone':'手机',
    'form.state':'地区',
    'form.city':'城市',
    'form.address':'地址',
    'form.reset':'重置',
    'form.submit':'提交',
    'form.registe-success':'注册成功',
    'form.registe-fail':'注册失败',
    'form.login-success':'登录成功',
    'form.policy.title':'隐私政策',
    'form.policy.require':'请查看并同意此政策',
    'form.policy.text':'查看隐私政策',
    'form.policy.evaluation-agreement':'我已同意评估协议的条款',
    'form.policy.reading-plant':'我已同意并阅读计划规则',
    'form.policy.efund-policy':'我已同意并退款政策',
    'form.submit.success':'提交成功',
    'form.submit.fail':'提交失败',
}